import React from 'react';
import Navbar from '../components/Navbar';
import ContentSplitSections from '../components/ContentSplitSections';
import { Link } from 'react-router-dom';
import '../styles/fencing.css';
import CTASection from '../components/CTASection';

// Fence data with placeholder images
const ranchFarmFencing = [
  {
    title: "High-Tension Fixed Knot Fencing",
    text: `The Premium Choice for Livestock Control\n\nOur high-tension fixed knot fencing represents the pinnacle of durability and functionality. The fixed knot system creates an incredibly strong junction between horizontal and vertical wires that won't slide or come apart. Combined with high-tensile steel wire, this creates a fence that can be stretched "fiddle string tight" for maximum structural integrity.\n\nKey Features:\n• Triple zinc coating for superior rust protection\n• Breaking point far exceeds traditional field fence\n• Solid wire vertical stays for added strength\n• Perfect for cattle, horses, sheep, and game animals`,
    image: "/images/fence/highTensionFixedKnotFencing.png",
    alt: "Fixed Knot Fence",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/Gallery"
  },
  {
    title: "Barbed Wire & Traditional Ranch Fencing",
    text: `Time-Tested Solutions for Property Management\n\nFrom simple boundary marking to complex livestock management systems, we install all types of traditional ranch fencing. Our team, led by Les Carberry with decades of livestock experience, designs facilities that prioritize both animal safety and handler efficiency.\n\nServices Include:\n• Three-strand barbed wire for boundaries\n• Corrals and handling facilities\n• Roping arenas and rodeo practice areas\n• Feed lots and sorting pens\n• Managed Intensive Grazing (MIG) systems`,
    image: "/images/fence/barbFencing.png",
    alt: "Ranch Fencing",
    reverse: true,
    buttonText: "View Our Work",
    buttonLink: "/Gallery"
  },
  {
    title: "Corrals and Arenas Fencing",
    text: `Protecting Property While Respecting Nature\n\nSun Valley's abundant wildlife requires specialized fencing solutions. Our game fencing effectively manages deer, elk, and other wildlife while maintaining the natural beauty of your property. We understand Idaho's unique challenges and design fences that work with the landscape.\n\nSpecialty Applications:\n• 8-foot deer exclusion fencing\n• Elk-resistant designs\n• Wildlife corridors and gates\n• Garden and orchard protection\n• Idaho Fish & Game compliant installations`,
    image: "/images/fence/coralsArenasFencing.png",
    alt: "Wildlife Fence",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/Gallery"
  }
];

const residentialDecorativeFencing = [
  {
    title: "Custom Wood Fencing",
    text: `Craftsmanship Meets Mountain Elegance\n\nFrom simple round post and rail systems to intricate doweled fences with exceptional detail, our wood fencing adds warmth and character to any property. Each fence is custom-designed to complement your home's architecture and the surrounding landscape.\n\nPopular Styles:\n• Classic post and rail\n• Privacy fencing with decorative tops\n• Split rail for rustic charm\n• Custom doweled designs\n• Cedar, pine, and other premium woods`,
    image: "images/fence/topRailFencing.png",
    alt: "Wood Fence",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/Gallery"
  },
  // {
  //   title: "Ornamental Steel & Iron",
  //   text: `Strength and Beauty Combined\n\nOur steel and iron fencing provides unmatched durability with elegant design options. Perfect for estate entrances, pool enclosures, or property perimeters, these fences offer security without sacrificing aesthetics. Let your imagination guide the design – we can create virtually any pattern or style.\n\nDesign Options:\n• Powder-coated finishes in any color\n• Custom scrollwork and decorative elements\n• Automated gate systems\n• Historic reproductions\n• Modern minimalist designs`,
  //   image: "https://via.placeholder.com/600x400/47475C/FFFFFF?text=Ornamental+Steel",
  //   alt: "Ornamental Steel",
  //   reverse: true,
  //   buttonText: "View Our Work",
  //   buttonLink: "/Gallery"
  // },
  {
    title: "Entry Structures & Gateways",
    text: `Make a Lasting First Impression\n\nYour driveway entrance sets the tone for your entire property. We create stunning entry structures that combine fencing, landscaping, and architectural elements. These gateways enhance curb appeal while providing security and defining your property's character.\n\nComplete Packages Include:\n• Steel or wood archways\n• Stone or masonry pillars\n• Automated gate systems\n• Landscape lighting\n• Integrated plantings and hardscaping`,
    image: "https://via.placeholder.com/600x400/A27BBF/FFFFFF?text=Entry+Gateway",
    alt: "Entry Gateway",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/Gallery"
  }
];

const Fence = () => {
  return (
    <div className="fence-page">
      <Navbar />
      {/* Hero Section */}
       <section className="fence-hero">
        <div>
              <img src="/images/fence/fenceHeroImage.png" alt="All Seasons Fence" className="hero-image" loading="eager" decoding="async" />
            </div>
        <div className="fence-hero-overlay">
          <div className="fence-hero-content">
            <h1 className="fence-hero-title">Expert Fencing Solutions for The Valley Properties</h1>
            <p className="fence-hero-subtitle">
              From working ranches to luxury estates – Function and Form perfectly balanced
            </p>
             <div className="hero-buttons">
                        <a
                      className="btn-cta"
                      href="mailto:info@allseasons.info"
                      target="_blank"
                      rel="noopener noreferrer"
                    >Request A Consultation</a>
                        <Link to="/gallery/landscape" className="btn-primary">Gallery</Link>
                      </div>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Complete Fencing Services</h2>
          <p className="intro-text text-center" style={{ maxWidth: '900px', margin: '0 auto 3rem auto' }}>
            All Seasons Landscaping brings decades of experience to every fencing project. Whether you need to contain livestock,
            protect gardens from wildlife, enhance security, or simply define your property boundaries with style, we deliver
            solutions that stand the test of time. Our team understands that three key factors guide every fence decision:
            Function, Form, and Budget – and we excel at balancing all three.
          </p>
          <div className="value-props-grid">
            <div className="value-prop-card">
              <div className="value-number">01</div>
              <h3>Custom Design</h3>
              <p className="value-description">
                Tailored solutions for your specific needs and property
              </p>
            </div>
            <div className="value-prop-card">
              <div className="value-number">02</div>
              <h3>Professional Installation</h3>
              <p className="value-description">
                Expert crews with specialized equipment
              </p>
            </div>
            <div className="value-prop-card">
              <div className="value-number">03</div>
              <h3>Repair & Maintenance</h3>
              <p className="value-description">
                Keep your investment looking and working great
              </p>
            </div>
            <div className="value-prop-card">
              <div className="value-number">04</div>
              <h3>Code Compliance</h3>
              <p className="value-description">
                Meeting all Idaho and local regulations
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ranch & Farm Fencing Section */}
      {/* <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Ranch & Farm Fencing</h2>
          <p className="section-intro">Professional livestock management and agricultural fencing solutions</p>
        </div>
      </section>

      <ContentSplitSections sections={ranchFarmFencing} /> */}

      {/* Residential & Decorative Section */}
      {/* <section className="section bg-soft-stone">
        <div className="section-inner">
          <h2 className="section-title text-center">Residential & Decorative Fencing</h2>
          <p className="section-intro">Enhance your property's beauty, privacy, and value</p>
        </div>
      </section>

      <ContentSplitSections sections={residentialDecorativeFencing} /> */}

      {/* Specialty Applications */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Specialty Fencing Applications</h2>
          <p className="section-intro">Unique solutions for Sun Valley's diverse fencing needs</p>
          
          <div className="specialty-grid">
            <div className="specialty-card fence-specialty-card">
              <h3>Snow Fencing</h3>
              <p className="application-type">Drift Control</p>
              <p>Strategic placement to manage snow accumulation and protect driveways, buildings, and sensitive areas.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Pool & Safety Fencing</h3>
              <p className="application-type">Code Compliant</p>
              <p>Meeting all safety requirements while maintaining your property's aesthetic appeal.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Construction Fencing</h3>
              <p className="application-type">Temporary Solutions</p>
              <p>Secure job sites and protect the public during your construction or renovation projects.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Pet Containment</h3>
              <p className="application-type">Custom Design</p>
              <p>Keep your furry friends safe with attractive fencing that complements your landscape.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Garden Protection</h3>
              <p className="application-type">Wildlife Resistant</p>
              <p>Protect vegetables, flowers, and ornamentals from deer, rabbits, and other garden visitors.</p>
            </div>
            <div className="specialty-card fence-specialty-card">
              <h3>Sound Barriers</h3>
              <p className="application-type">Privacy Plus</p>
              <p>Reduce noise from roads or neighbors while creating private outdoor spaces.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
     <CTASection 
  title="Ready to Define Your Boundaries?"
  subtitle="From initial consultation through final installation, we make fencing simple. Let's discuss your project and find the perfect solution for your property."
  galleryLink="/Gallery/fencing"
  showEmergency={false}
/>
    </div>
  );
};

export default Fence;